import ProjectPackage from '../../components/projectPackage/ProjectPackage.vue'
import NewCourseDetails from '../../components/newcourseDetails/CourseDetails.vue'
// 旧的组件  小课程模块
// import CourseDetails from '../../components/courseDetails/CourseDetails.vue'
import RecommendedCourse from '../../components/recommendedCourse/RecommendedCourse.vue'
import RecommendedCourseRotationChart from '../../components/recommendedCourseRotationChart/RecommendedCourseRotationChart.vue'
import List01 from '../../components/list01/List01.vue'
import List02 from '../../components/list02/List02.vue'
import List03 from '../../components/list03/List03.vue'
import List04 from '../../components/list04/List04.vue'
import List05 from '../../components/list05/list05.vue'
import rightInformation from '../../components/rightInformation/rightInformation.vue'
import project from '../../components/project/Project.vue'
// 客服信息模块
import ServiceInformation from '../ServiceInformation/ServiceInformation.vue'
// 之前的组件的样式  
import Banner from '../banner/banner.vue'

// 课程套餐的组件
import ProductCategory from '../../components/product-category/ProductCategory.vue'

// 改变后的组件的样式 
// import Banner from '../../components/banner/banner.vue'

// 引入郑州畅和二维码组件
import QrCode from '../../components/qr-code/QrCode.vue'

// 引入郑州人才二维码组件
import ZZRCQrCode from '../../components/zzrc-qr-code/ZZRCQrCode.vue'

export default {
    data() {
        return {
            //控制手风琴

            //标签
            labels: {
                id: '0'
            },
            //轮播图
            sliderImgs: [],
            //推荐课程
            recommendCourseImg: [],
            // 板块数组
            sections: [],
            //搜索项目包输入的文字
            searchPackageName: "",
            // 新闻列表
            newsList: [
                '中央政府门户网站：知行中国-中小学班主任教师国家级远程培训班开班',
                '中国教育新闻网："知行中国—中小学班主任国家级远程培训"开班',
                '光明日报：10万班主任参加“知行中国”远程培训',
                '中国新闻网：中国将远程培训10万名小学一线班主任教师',
                '中国教育报：问题解决让远程研修更接地气',
                '【中国教育报】信息技术与教师培训深度融合'
            ],
            // 通知列表
            informList: [{
                id: 1,
                year: '2019',
                time: '12.18',
                title: '中央财政下达19.85亿元，用于乡村中小幼教师培训'
            },
            {
                id: 2,
                year: '2019',
                time: '12.18',
                title: '聚焦！4月18日-19日，第十届长三角基础教育课程与教学改革论坛即将召开'
            },
            {
                id: 3,
                year: '2019',
                time: '12.18',
                title: '全国中小学教师信息技术应用能力提升工程2.0启动'
            }
            ],
            // 当前页
            currentPage: 1,
            // 每页显示条数
            pageSize: 15,
            // 总条数
            total: 0,
            // 是显示客服区域还是二维码区域，根据shop_id判断，isShow==1是客服区域，isShow==2是二维码区域
            isShow: 0,
            // 刚打开网页时的弹出框
            firstDialog: false,
			shopID:''
        }
    },
    methods: {

        //获取首页数据
        getdata() {
            //获取板块信息
            this.$getStoreId().then(id => {
                this.$post('product_category/get_year', {
                    available: 1,
                    offset: 0,
                    length: 999
                }).then(res => {
                    // console.log(res)
                    let yearArr = res.data.result.data
                    let allProducts = []
					
					
					this.$post('product_category/search_products', {
						shop_id: id,
						available: 1,
						offset: 0,
						length: 5,
						year: yearArr[0].year,
                        ban_594: 1,
					}).then(res => {
						this.sections = yearArr
						this.sections[0].products = res.data.result.data
						this.sections[0].total = res.data.result.total
						console.log(this.sections,'1')
					})

       //              yearArr.map(item => {
       //                  this.$post('product_category/search_products', {
       //                      shop_id: id,
       //                      available: 1,
       //                      offset: 0,
       //                      length: 999,
       //                      year: item.year
       //                  }).then(res => {
							// if(res.data.result.total){
							// 	console.log(res)
							// 	let obj = {}
							// 	obj.year = item.year
							// 	obj.products = res.data.result.data
								
							// 	allProducts.push(obj);
							// 	for (let i = 0; i < allProducts.length - 1; i++) { //控制比较的轮数
							// 	    for (let j = 0; j < allProducts.length - 1 - i; j++) { //控制比较的次数
							// 	        //用第三方变量交换值
							// 	        if (allProducts[j].year < allProducts[j + 1].year) {
							// 	            let temp = allProducts[j];
							// 	            allProducts[j] = allProducts[j + 1];
							// 	            allProducts[j + 1] = temp;
							// 	        }
							// 	    }
							// 	}
							
							// 	this.sections = allProducts
							// 	// this.sections = this.setAllTotal(allProducts)
							// 	// this.sections.push(obj);
							// 	// console.log(this.sections)
							// 	// this.total = res.data.result.total;
							// 	//因为返回的对象里面的数组有产品数组，也有项目包数组，若
							// 	// this.sections.map(item => {
							// 	//     //若产品数组为空则删除产品数组这个属性
							// 	//     // if (item.product_category_mapping.length == 0) {
							// 	//     //     item.section_products = item.package_section;
							// 	//     // }
							// 	//     //删除项目包数组这个属性
							// 	//     delete item.package_section;
							// 	// })
							// 	// 请求得到的数据的操作  
							// 	// console.log(this.sections);
							// }
							
       //                  })
       //              })
                })

            })

        },

        //计算价格并填入数组
        setAllTotal(arr) {
            let newArr = arr
            newArr.map(item => {
                item.products.map(item1 => {
                    let price = 0;
                    item1.product_category_mapping.map(item2 => {
                        price += Number.parseFloat(item2.product_price);
                    })

                    item1.price = price
                })
            })
            return newArr
        },

        // 每页显示数目变化时调用
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.getdata();
        },

        // 当前页改变时调用
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage;
            this.getdata()
        }
    },
    components: {
        List01,
        List02,
        List03,
        List04,
        List05,
        ProjectPackage,
        NewCourseDetails,
        // CourseDetails,
        RecommendedCourse,
        RecommendedCourseRotationChart,
        ServiceInformation,
        "banner-app": Banner,
        "Project": project,
        ProductCategory,
        QrCode,
        ZZRCQrCode,
        rightInformation
    },
    mounted: function () {
        this.getdata();

        // // // 线上 start
        // let url = "";
        // let hostName = window.location.hostname;
        // // 指向人才
        // let belongToZZRC = `
        // jxjy.zzrc.cn,
        // http://zzrc-uat.ca163.net.cn,
        // http://zzrc.ca163.net,
        // https://zzrc.ca163.net,
        // zzrc-uat.ca163.com`;
        // if (belongToZZRC.includes(hostName)) {
        //     url = "http://zzrc.ca163.net";
        // } else {
        //     url = window.location.origin;
        // }
        // // 指向畅和
        // let belongToZZCH = `zzch-uat.ca163.net.cn,
        // zzch.ca163.net,
        // zzch-uat.ca163.com,
        // http://jxjy.zzzjedu.com`;
        // if (belongToZZCH.includes(hostName)) {
        //     url = "http://zzch-test.ca163.net";
        // } else {
        //     url = window.location.origin;
        // }
        // // 线上 end
	
        // 本地测试
        let url = this.testUrl;//

        this.$post("shops/get", { url: url }).then(res => {
            // shopId为107是郑州人才显示客服区域，否则是郑州畅和显示二维码区域
            let shopId = res.data.result.id;
			this.shopID = shopId
			this.$store.state.newShopId = res.data.result.id
            if (shopId == 107) {
                this.isShow = 1;
				// this.firstDialog = true;
            } else {
                this.isShow = 2;
                // this.firstDialog = true;
            }
            // shopId == 107 ? this.isShow = 1: this.isShow = 2;

        });

    },
    created() {

        document.title = this.$store.state.store ? this.$store.state.store.platform_name : '';

    }
}
